import packageJson from '../../../package.json'
import {
  LS_EMAIL,
  LS_PASSWORD,
  LS_REMEMBER_LOGIN,
  LS_USER_ID,
  LS_USER_INFO,
} from 'utils/constants/localStorage'

export const caching = () => {
  const version = localStorage.getItem('version')
  if (version !== packageJson.version) {
    if ('caches' in window) {
      caches.keys().then((names) => {
        // Delete all the cache files
        names.forEach((name) => {
          caches.delete(name)
        })
      })
    }

    document.cookie = 'mtcUsrToken=; Max-Age=0; path=/;'
    localStorage.removeItem(LS_USER_INFO)
    localStorage.removeItem(LS_USER_ID)
    localStorage.removeItem(LS_EMAIL)
    localStorage.removeItem(LS_PASSWORD)
    localStorage.removeItem(LS_REMEMBER_LOGIN)
    localStorage.removeItem('version')
    localStorage.setItem('version', packageJson.version)
    // Makes sure the page reloads. Changes are only visible after you refresh.
    window.location.reload()
  }
}
